import { Button } from 'components/shared/Button';
import { FormInputText } from 'components/shared/FormInputText';
import { FC, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { ResetPasswordData } from 'api/adminApi';
import {
  selectRejectedMessage,
  selectResetPasswordConfirmStatus,
  selectResetPasswordStatus,
} from 'redux/admin/selectors';
import { useAppDispatch, useAppSelector } from 'redux/store';
import styles from '../AdminView.module.scss';
import { AdminPanel } from 'utils/strings';
import {
  fetchResetPassword,
  fetchResetPasswordConfirm,
} from 'redux/admin/thunks';
import { resetPasswordSchema, emailSchema } from '../SigIn/schema';
import { useLocation } from 'react-router-dom';
import { Texts } from 'components/shared/Texts';

interface ResetPasswordViewProps {
  routeTo: () => void;
}
const ResetPasswordView: FC<ResetPasswordViewProps> = ({ routeTo }) => {
  const dispatch = useAppDispatch();
  const isResetSucceeded = useAppSelector(selectResetPasswordStatus);
  const isResetConfirmSucceeded = useAppSelector(
    selectResetPasswordConfirmStatus
  );
  const error = useAppSelector(selectRejectedMessage);
  const location = useLocation();

  const [tokenData, setTokenData] = useState({ user: '', uuid: '' });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const uuid = searchParams.get('uuid');
    const user = searchParams.get('user');

    setTokenData({ user: user as string, uuid: uuid as string });
  }, []);

  useEffect(() => {
    if (isResetConfirmSucceeded) {
      routeTo();
    }
  }, [isResetConfirmSucceeded]);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<ResetPasswordData>({
    defaultValues: {
      value: '',
    },
    mode: 'onChange',
    resolver: tokenData.user
      ? yupResolver(resetPasswordSchema)
      : yupResolver(emailSchema),
  });

  const onSubmit = (data: ResetPasswordData) => {
    void dispatch(fetchResetPassword(data));
  };
  const onSubmitConfirm = (data: ResetPasswordData) => {
    const requestdata = {
      value: data.value.toString(),
      user: tokenData.user,
      token: tokenData.uuid,
    };
    void dispatch(fetchResetPasswordConfirm({ ...requestdata }));
  };

  return (
    <section className={styles.login_view}>
      <h1>
        {tokenData.user
          ? AdminPanel.Reset.Confirm.h1.toUpperCase()
          : AdminPanel.Reset.h1.toUpperCase()}
      </h1>
      <p className={styles.text}>
        {tokenData.user
          ? AdminPanel.Reset.Confirm.instruction
          : AdminPanel.Reset.instruction}
      </p>
      <form
        className="form"
        onSubmit={(event) =>
          void handleSubmit(tokenData.user ? onSubmitConfirm : onSubmit)(event)
        }
      >
        <FormInputText
          name="value"
          placeholder={
            tokenData.user ? AdminPanel.SigIn.password : AdminPanel.Reset.email
          }
          error={!!errors.value}
          control={control}
          type={tokenData.user ? 'password' : 'text'}
        />
        {(error === AdminPanel.Errors.Api.incorrectOldPassword ||
          !!errors.value) && (
          <div className={styles.login_error}>
            <Texts className={styles.error_text}>
              <span className={styles.text_icon}></span>
              {errors.value
                ? errors.value.message
                : AdminPanel.Errors.incorrectPassword}
            </Texts>
          </div>
        )}
        <section>
          <Button
            className={styles.button_styles}
            buttonType="submit"
            disabled={!!errors.value || isResetSucceeded}
          >
            {isResetSucceeded
              ? 'Wysłano e-mail'
              : tokenData.user
              ? AdminPanel.Reset.Confirm.button
              : AdminPanel.Reset.button}
          </Button>
          <a
            className={styles.reset}
            href={'/admin'}
            hidden={tokenData.user !== ''}
          >
            {AdminPanel.Reset.return}
          </a>
        </section>
      </form>
    </section>
  );
};
export default ResetPasswordView;
